import { WidgetRegistry } from "@Widgets/types";
import { TaskCreationBlockedModalRoot } from "../Containers/TaskCreationBlockedModalRoot/TaskCreationBlockedModalRoot";

const sharedWidgetRegistry: Pick<WidgetRegistry, "TasksCreation.BlockedModal"> =
  {
    "TasksCreation.BlockedModal": {
      Component: TaskCreationBlockedModalRoot,
    },
  };

export default sharedWidgetRegistry;
